export default "__VITE_ASSET__B1cB_hdx__"